module.exports = __webpack_public_path__ + "68728d13cca51c06f2f418662a2ed02d.jpg";